<template>
  <b-navbar>
    <template #brand>
      <b-navbar-item tag="router-link" :to="{ path: '/' }">
        <img
          v-if="!isEmpty($store.state.universities.active)"
          :src="$store.state.universities.active.logoRightText"
        />
        <img v-else src="/assets/img/logo-white-new.png" />
      </b-navbar-item>
    </template>

    <template #end>
      <b-navbar-item tag="div">
        <div class="buttons">
          <nuxt-link class="button is-primary" :to="{name: 'login'}">Masuk</nuxt-link>
          <nuxt-link class="button is-light" :to="{name: 'register'}">Daftar</nuxt-link>
        </div>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import DownloadAppNotif from "~/components/DownloadAppNotif";

export default {
  components: {
    DownloadAppNotif
  },

  watch: {
    $route() {
      this.active = false;
    }
  },

  data() {
    return {
      active: false
    };
  }
};
</script>
